module.exports = new __parcel__URL__("SearchByTown.c32bd105.jpg").toString();